// extracted by mini-css-extract-plugin
module.exports = {"menu-item":"_3M0ovQLjwtwsl3fO_LeOTU"};